<template>
  <section>
    <Header>
      <Heading1>Frequently Asked Questions</Heading1>
    </Header>

    <Content>
      <Accordion>
        <AccordionItem v-for="(faq, i) in faqList" :key="i" :name="faq.tag">
          <Accordion>
            <AccordionItem v-for="(children, i) in faq.children" :key="i" :name="children.question">
              <AccordionContent v-html="children.answer">
              </AccordionContent>
            </AccordionItem>
          </Accordion>
        </AccordionItem>
      </Accordion>
    </Content>
  </section>
</template>

<script>
import Header from '../components/base/Header.vue';
import Heading1 from '../components/base/Heading1.vue';
import Content from '../components/base/Content.vue';
import Accordion from '../components/base/accordion/Accordion.vue';

// Data
import faqList from '~/content/faq/data.json'
import AccordionItem from '../components/base/accordion/AccordionItem.vue';
import AccordionContent from '../components/base/accordion/AccordionContent.vue';

export default {
  head() {
    const { path = "" } = this.$route;

    const metaTitle = 'FAQ' + " | Macher Jobs";
    const metaDescription = `Here you will find answers to your questions about how to use macherusa.com`
    const canonical = process.env.baseUrl + path;

    return {
      title: metaTitle,
      link: [{ rel: "canonical", href: canonical }],
      meta: this.createMetaTags({
        description: metaDescription,
        title: metaTitle,
        canonical,
        socialTitle: metaTitle,
        socialDescription: metaDescription,
        siteName: "Macher Jobs",
        twitter: "@FrumJewishJobs",
      }),
    };
  },
  data: function () {
    return {
      faqList
    };
  },

  components: {
    Header,
    Heading1,
    Content,
    Accordion,
    AccordionItem,
    AccordionContent
  }
};
</script>